var swiper = new Swiper(".mySwiperTestimonialslider", {
    slidesPerView: "1",
    spaceBetween: 30,
    pagination: {
        el: ".testimonialcarousel-pagination",
        clickable: true,
    },
    navigation: {
        nextEl: ".t-swiper-button-next",
        prevEl: ".t-swiper-button-prev",
    },
    breakpoints: {
        500: {
            slidesPerView: 1,
        },
        768: {
            slidesPerView: 2,
        },
        992: {
            slidesPerView: 3,
            navigation: {
                nextEl: ".t-swiper-button-next",
                prevEl: ".t-swiper-button-prev",
            }
        },
        1024: {
            slidesPerView: 3,
            navigation: {
                nextEl: ".t-swiper-button-next",
                prevEl: ".t-swiper-button-prev",
            }
        },
        1400: {
            slidesPerView: 4,
        },
    },
});


document.addEventListener('DOMContentLoaded', function () {
    const reviewCards = document.querySelectorAll('.testimonial-cards');
    const reviewRows = document.querySelectorAll('.testimonial-slider-m');
    
    let maxCardHeight = 0;
    let maxRowHeight = 0;

    // Find the maximum height for review cards
    reviewCards.forEach(card => {
        const cardHeight = card.offsetHeight;
        if (cardHeight > maxCardHeight) {
            maxCardHeight = cardHeight;
        }
    });

    // Apply the maximum height to all review cards
    reviewCards.forEach(card => {
        card.style.height = `${maxCardHeight}px`;
    });

    // Find the maximum height for review rows
    reviewRows.forEach(row => {
        const rowHeight = row.offsetHeight;
        if (rowHeight > maxRowHeight) {
            maxRowHeight = rowHeight;
        }
    });

    // Apply the maximum height to all review rows
    reviewRows.forEach(row => {
        row.style.height = `${maxRowHeight}px`;
    });
});

